import React from 'react';
import AuthInfo from '../molecules/AuthInfo';
import { Button } from '../buttons';

const SignUpForm = (props) => (
  <form>
    <p>Pengguna baru? Silahkan masukkan nama lengkap, email, dan password kamu</p>
    <div className="form-row">
      <div className="form-group col-md-6">
        <input
          type="text"
          onChange={props.handleChange('firstName')}
          placeholder="Nama Depan"
          className="form-control"
          value={props.values.firstName}
          />
      </div>

      <div className="form-group col-md-6">
        <input
          type="text"
          onChange={props.handleChange('lastName')}
          placeholder="Nama Belakang"
          className="form-control"
          value={props.values.lastName}
          />
      </div>
    </div>
    <div className="form-group">
      <input
        type="text"
        onChange={props.handleChange('email')}
        placeholder="Email"
        className="form-control"
        value={props.values.email}
        />
    </div>

    <div className="form-group">
      <input
        type="password"
        onChange={props.handleChange('password')}
        placeholder="Password"
        className="form-control"
        value={props.values.password}
        />
    </div>
    <Button
      onClick={props.onSubmit}
      loading={props.loading}
      className="btn btn-primary btn-block"
      >
      {props.loading ? "Submitting..." : "Submit"}
    </Button>

    <AuthInfo type="signup"/>
  </form>
)


export default SignUpForm
